import { MemberRole } from '@lucidlink/dto/validation';
export const toCurrentMemberViewModel = (data) => ({
    ...data,
    isOwner: data.role === MemberRole.OWNER,
    isAdmin: data.role === MemberRole.ADMIN,
    isFilespaceAdmin: data.role === MemberRole.FILESPACE_ADMIN,
    isCollaborator: data.role === MemberRole.COLLABORATOR,
    isGuest: data.role === MemberRole.GUEST,
    isServiceAccount: data.role === MemberRole.SERVICE_ADMIN ||
        data.role === MemberRole.SERVICE_COLLABORATOR,
});
